import { Fragment } from 'react';
import styles from '../kyc-intelligence.module.css';

function MobileDetails({details}) {

    return (<>
        <div className={styles['basic-report-box']}>
            <h2>Mobile details</h2>
            {details.map((item, index) => {
                const age = item?.age?.result;
                const identity = item?.identity?.result;
                const aadhaarLink = item?.aadhaarLink;
                const address = item?.address?.result;
                const employment = item?.employmentHistory?.result;

                return (
                    <Fragment key={index}>
                        <h3>Phone number - {item?.mobileNumber}</h3>
                        <h4>Aadhaar link</h4>
                        <div className={styles['basic-report-details']}>
                            <div>
                                <span>Status: </span>
                                {aadhaarLink?.status ? String(aadhaarLink?.status) : 'false'}
                            </div>
                            <div>
                                <span>Message: </span>
                                {aadhaarLink?.message || '-'}
                            </div>
                        </div>
                        <h4>Delivery address</h4>
                        {address?.map((addressItem, addressIndex) => (
                            <div key={addressIndex}>
                                <h5>Address {addressIndex+1}</h5>
                                <div className={styles['basic-report-details']}>
                                    <div>
                                        <span>First name: </span>
                                        {addressItem?.first_name || '-'}
                                    </div>
                                    <div>
                                        <span>Last name: </span>
                                        {addressItem?.last_name || '-'}
                                    </div>
                                    <div>
                                        <span>Email: </span>
                                        {addressItem?.email || '-'}
                                    </div>
                                    <div>
                                        <span>ISD code: </span>
                                        {addressItem?.isd_code || '-'}
                                    </div>
                                    <div>
                                        <span>Address line 1: </span>
                                        {addressItem?.line1 || '-'}
                                    </div>
                                    <div>
                                        <span>Address line 2: </span>
                                        {addressItem?.line2 || '-'}
                                    </div>
                                    <div>
                                        <span>City: </span>
                                        {addressItem?.city || '-'}
                                    </div>
                                    <div>
                                        <span>State: </span>
                                        {addressItem?.state || '-'}
                                    </div>
                                    <div>
                                        <span>Country: </span>
                                        {addressItem?.country || '-'}
                                    </div>
                                    <div>
                                        <span>Country code: </span>
                                        {addressItem?.country_code || '-'}
                                    </div>
                                    <div>
                                        <span>Pincode: </span>
                                        {addressItem?.pincode || '-'}
                                    </div>
                                    <div>
                                        <span>Last delivery date: </span>
                                        {addressItem?.last_delivery_date || '-'}
                                    </div>
                                </div>
                            </div>
                        ))}
                        <h4>Age</h4>
                        <div className={styles['basic-report-details']}>
                            <div>
                                <span>Has porting history: </span>
                                {age?.has_porting_history || '-'}
                            </div>
                            <div>
                                <span>Mobile age: </span>
                                {age?.mobile_age || '-'}
                            </div>
                            <div>
                                <span>Is number active: </span>
                                {age?.is_number_active || '-'}
                            </div>
                            <div>
                                <span>Is number valid: </span>
                                {age?.is_number_valid || '-'}
                            </div>
                            <div>
                                <span>Original region: </span>
                                {age?.original_region || '-'}
                            </div>
                            <div>
                                <span>Original telecom provider: </span>
                                {age?.original_telecom_provider || '-'}
                            </div>
                            <div>
                                <span>Roaming: </span>
                                {age?.roaming || '-'}
                            </div>
                        </div>
                        <h4>Identity</h4>
                        <h5>Personal info</h5>
                        <div className={styles['basic-report-details']}>
                            {
                                identity?.personal_info
                                ?<>
                                    <div>
                                        <span>Full name: </span>
                                        {identity?.personal_info?.full_name || '-'}
                                    </div>
                                    <div>
                                        <span>DOB: </span>
                                        {identity?.personal_info?.dob || '-'}
                                    </div>
                                    <div>
                                        <span>Gender: </span>
                                        {identity?.personal_info?.gender || '-'}
                                    </div>
                                    <div>
                                        <span>Total income: </span>
                                        {identity?.personal_info?.total_income || '-'}
                                    </div>
                                    <div>
                                        <span>Occupation: </span>
                                        {identity?.personal_info?.occupation || '-'}
                                    </div>
                                    <div>
                                        <span>Age: </span>
                                        {identity?.personal_info?.age || '-'}
                                    </div>
                                </>
                                :<div>No details found</div>
                            }
                        </div>
                        <h5>Phone info</h5>
                        {
                            identity?.phone_info===undefined || identity?.phone_info===null || identity?.phone_info?.length===0
                            ?<div className={styles['basic-report-details']}>
                                <div>No details found</div>
                            </div>
                            :<table className="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Number</th>
                                        <th>Type code</th>
                                        <th>Reported date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {identity?.phone_info?.map((addressItem, addressIndex) => (
                                        <tr key={addressIndex}>
                                            <td>{addressIndex+1}</td>
                                            <td>{addressItem?.number}</td>
                                            <td>{addressItem?.type_code}</td>
                                            <td>{addressItem?.reported_date}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        }
                        <h5>Address info</h5>
                        {
                            identity?.address_info===undefined || identity?.address_info===null || identity?.address_info?.length===0
                            ?<div className={styles['basic-report-details']}>
                                <div>No details found</div>
                            </div>
                            :<table className="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Address</th>
                                        <th>Postal</th>
                                        <th>Reported date</th>
                                        <th>State</th>
                                        <th>Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {identity?.address_info?.map((addressItem, addressIndex) => (
                                        <tr key={addressIndex}>
                                            <td>{addressIndex+1}</td>
                                            <td>{addressItem?.address}</td>
                                            <td>{addressItem?.postal}</td>
                                            <td>{addressItem?.reported_date}</td>
                                            <td>{addressItem?.state}</td>
                                            <td>{addressItem?.type}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        }
                        <h5>Email info</h5>
                        {
                            identity?.email_info===undefined || identity?.email_info===null || identity?.email_info?.length===0
                            ?<div className={styles['basic-report-details']}>
                                <div>No details found</div>
                            </div>
                            :<table className="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Email address</th>
                                        <th>Reported date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {identity?.email_info?.map((emailItem, emailIndex) => (
                                        <tr key={emailIndex}>
                                            <td>{emailIndex+1}</td>
                                            <td>{emailItem?.email_address}</td>
                                            <td>{emailItem?.reported_date}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        }
                        <h5>Identity info</h5>
                        {
                            identity?.identity_info?.pan_number===undefined || identity?.identity_info?.pan_number===null || identity?.identity_info?.pan_number?.length===0
                            ?<div className={styles['basic-report-details']}>
                                <div>No details found</div>
                            </div>
                            :<table className="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>ID number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {identity?.identity_info?.pan_number?.map((identityItem, identityIndex) => (
                                        <tr key={identityIndex}>
                                            <td>{identityIndex+1}</td>
                                            <td>{identityItem?.id_number}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        }
                        <h5>Employment history</h5>
                        {
                            employment===undefined || employment===null || employment?.length===0
                            ?<div className={styles['basic-report-details']}>
                                <div>No details found</div>
                            </div>
                            :<table className="table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Guardian name</th>
                                        <th>Establishment name</th>
                                        <th>Member id</th>
                                        <th>Date of joining</th>
                                        <th>Date of exit</th>
                                        <th>UAN</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {employment?.map((employmentItem, employmentIndex) => (
                                        <tr key={employmentIndex}>
                                            <td>{employmentIndex+1}</td>
                                            <td>{employmentItem?.name}</td>
                                            <td>{employmentItem?.guardian_name}</td>
                                            <td>{employmentItem?.establishment_name}</td>
                                            <td>{employmentItem?.member_id}</td>
                                            <td>{employmentItem?.date_of_joining}</td>
                                            <td>{employmentItem?.date_of_exit}</td>
                                            <td>{employmentItem?.uan}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        }
                        <h5>RC details</h5>
                        <div className={styles['basic-report-details']}>
                            {
                                item?.rcDetails?.result?.length===0||item?.rcDetails?.result?.length===undefined
                                ?<div> No details found </div>
                                :item?.rcDetails?.result?.map((rcItem, rcIndex) => (
                                    <div key={rcIndex}> <span>{rcIndex+1}: </span>{rcItem} </div>
                                ))
                            }
                        </div>
                    </Fragment>
                )
            })}
        </div>
    </>);
}

export default MobileDetails;